"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _reactDropzone = _interopRequireDefault(require("react-dropzone"));
var _classnames = _interopRequireDefault(require("classnames"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));
var _action_mol = require("../actions/action_mol");
const styles = () => ({
  root: {
    flexGrow: 1
  },
  baseDD: {
    border: '2px dashed #000',
    borderRadius: 5,
    height: 30,
    lineHeight: '30px',
    margin: '0 0 10px 0',
    textAlign: 'center',
    verticalAlign: 'middle',
    width: '90%'
  },
  tpCard: {},
  tpLabel: {
    fontSize: 16
  }
});
const tpHint = classes => /*#__PURE__*/_react.default.createElement("span", {
  className: (0, _classnames.default)(classes.tpCard)
}, /*#__PURE__*/_react.default.createElement("p", {
  className: (0, _classnames.default)(classes.tpLabel, 'txt-sv-tp')
}, "- Accept *.mol"), /*#__PURE__*/_react.default.createElement("p", {
  className: (0, _classnames.default)(classes.tpLabel, 'txt-sv-tp')
}, "- Max 30Mb"));
const msgDefault = 'Add Molfile';
const showByMolfile = molSt => {
  const {
    src,
    mass
  } = molSt;
  if (src) {
    const txtMass = parseFloat(mass).toFixed(2);
    return "".concat(src.name, " (").concat(txtMass, "g/mol)");
  }
  return msgDefault;
};
const content = (classes, desc) => /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
  title: tpHint(classes),
  placement: "bottom"
}, /*#__PURE__*/_react.default.createElement("span", null, desc));
const InputMol = _ref => {
  let {
    classes,
    molSt,
    addMolInitAct
  } = _ref;
  const onDrop = mols => addMolInitAct({
    mol: mols[0]
  });
  const desc = showByMolfile(molSt, classes);
  return /*#__PURE__*/_react.default.createElement(_reactDropzone.default, {
    className: "dropbox",
    onDrop: onDrop
  }, _ref2 => {
    let {
      getRootProps,
      getInputProps
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, getRootProps(), {
      className: (0, _classnames.default)(classes.baseDD)
    }), /*#__PURE__*/_react.default.createElement("input", getInputProps()), content(classes, desc));
  });
};
const mapStateToProps = (state, props) => (
// eslint-disable-line
{
  molSt: state.mol
});
const mapDispatchToProps = dispatch => (0, _redux.bindActionCreators)({
  addMolInitAct: _action_mol.addMolInit
}, dispatch);
InputMol.propTypes = {
  classes: _propTypes.default.object.isRequired,
  molSt: _propTypes.default.object.isRequired,
  addMolInitAct: _propTypes.default.func.isRequired
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _withStyles.default)(styles)(InputMol));